import styled from "styled-components";

export const StarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
`